import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMariadbComponent } from './simple-icons-mariadb.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMariadbComponent ],
    exports:      [ SimpleIconsMariadbComponent ],
    bootstrap:    []
})
export class SimpleIconsMariadbModule {}
